module.exports = __webpack_public_path__ + "img/Rectangle 19.dffdf1f8.png";